/* Mister Dalle - recherche instantanée
 * Remplace l'ancien menu de suggestions (qui affichait tous les produits contenant un seul des mots tapés).
 * Règle : TOUS les mots tapés doivent correspondre (« dalle noir » ne montre que les dalles noires).
 * Les produits sont chargés une seule fois puis gardés en cache navigateur (1 h).
 */
(function () {
  'use strict';

  var CACHE_KEY = 'md-search-index-v2';
  var CACHE_MS = 60 * 60 * 1000;
  var MAX_RESULTS = 8;
  var MIN_CHARS = 2;

  var indexPromise = null;
  var money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function thumb(src) {
    if (!src) return '';
    return src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_160x$1$2');
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.time < CACHE_MS && cached.items && cached.items.length) {
        indexPromise = Promise.resolve(cached.items);
        return indexPromise;
      }
    } catch (e) { /* stockage indisponible : on recharge simplement */ }

    indexPromise = (function fetchPage(page, acc) {
      return fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('index'); return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          products.forEach(function (p) {
            var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(isFinite);
            var title = p.title || '';
            acc.push({
              t: title,
              h: p.handle,
              p: prices.length ? Math.min.apply(null, prices) : null,
              i: p.images && p.images[0] ? p.images[0].src : '',
              a: (p.variants || []).some(function (v) { return v.available; }),
              n: normalize(title),
              x: normalize([p.product_type, (p.tags || []).join ? p.tags.join(' ') : p.tags].join(' '))
            });
          });
          if (products.length === 250 && page < 10) return fetchPage(page + 1, acc);
          return acc;
        });
    })(1, []).then(function (items) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), items: items })); } catch (e) { /* ignore */ }
      return items;
    }).catch(function (err) {
      indexPromise = null; // permet de réessayer à la frappe suivante
      throw err;
    });

    return indexPromise;
  }

  // Équivalences du vocabulaire du site (le menu dit « luminaires », les produits s'appellent « éclairage LED »)
  var SYNONYMS = {
    luminaire: ['eclairage', 'led'],
    lumiere: ['eclairage', 'led'],
    lampe: ['eclairage', 'led'],
    spot: ['eclairage', 'led'],
    suspension: ['filin', 'filins'],
    fixation: ['filin', 'filins', 'kit'],
    carrelage: ['dalle'],
    sol: ['dalle']
  };

  function variants(token) {
    var out = [token];
    // pluriel : « dalles » -> « dalle », « luminaires » -> « luminaire »
    var stem = token.length > 3 ? token.replace(/(s|x)$/, '') : token;
    if (stem !== token) out.push(stem);
    var syn = SYNONYMS[stem];
    if (syn) out = out.concat(syn);
    return out;
  }

  function search(items, query) {
    var q = normalize(query);
    if (q.length < MIN_CHARS) return [];
    var tokens = q.split(' ');

    var scored = [];
    items.forEach(function (item) {
      var titleWords = item.n.split(' ');
      var allWords = titleWords.concat(item.x ? item.x.split(' ') : []);
      var score = 0;

      for (var k = 0; k < tokens.length; k++) {
        var alts = variants(tokens[k]);
        var inTitle = alts.some(function (tk) { return titleWords.some(function (w) { return w.indexOf(tk) === 0; }); });
        var inAny = inTitle || alts.some(function (tk) { return allWords.some(function (w) { return w.indexOf(tk) === 0; }); });
        var inside = alts.some(function (tk) { return tk.length >= 3 && item.n.indexOf(tk) !== -1; }); // « damier » dans « damiers », etc.
        if (!inAny && !inside) return; // un mot ne correspond pas : produit exclu
        score += inTitle ? 10 : inside ? 6 : 3;
      }

      if (item.n.indexOf(q) === 0) score += 60;
      else if (item.n.indexOf(q) !== -1) score += 30;
      if (item.a) score += 4;
      scored.push({ item: item, score: score });
    });

    scored.sort(function (a, b) { return b.score - a.score || a.item.t.localeCompare(b.item.t, 'fr'); });
    return scored.map(function (s) { return s.item; });
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function panelFor(input) {
    var form = input.closest('form');
    if (!form) return null;
    var panel = form.querySelector('.md-search-results');
    if (!panel) {
      form.style.position = 'relative';
      panel = document.createElement('ul');
      panel.className = 'md-search-results';
      panel.setAttribute('role', 'listbox');
      panel.hidden = true;
      form.appendChild(panel);
      // L'ancien script ajoutait sa propre liste : on la retire pour éviter les doublons
      var old = form.querySelector('ul.search-results');
      if (old) old.remove();
    }
    return panel;
  }

  function render(input, results, query) {
    var panel = panelFor(input);
    if (!panel) return;
    panel.innerHTML = '';
    panel.dataset.active = '-1';

    if (!results.length) {
      panel.innerHTML = '<li class="md-search-empty">Aucun résultat pour « ' + escapeHtml(query) + ' »</li>';
      panel.hidden = false;
      return;
    }

    var html = results.slice(0, MAX_RESULTS).map(function (r, idx) {
      return '<li role="option" data-idx="' + idx + '"><a href="/products/' + encodeURIComponent(r.h) + '">' +
        '<span class="md-search-thumb">' + (r.i ? '<img src="' + escapeHtml(thumb(r.i)) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
        '<span class="md-search-info"><span class="md-search-title">' + escapeHtml(r.t) + '</span>' +
        '<span class="md-search-price">' + (r.p !== null ? money.format(r.p) : '') + (r.a ? '' : ' · Indisponible') + '</span></span>' +
        '</a></li>';
    }).join('');

    if (results.length > MAX_RESULTS) {
      html += '<li class="md-search-all"><a href="/search?type=product&q=' + encodeURIComponent(query) + '">Voir les ' + results.length + ' résultats</a></li>';
    }

    panel.innerHTML = html;
    panel.hidden = false;
  }

  function closeAll(except) {
    document.querySelectorAll('.md-search-results').forEach(function (p) {
      if (p !== except) p.hidden = true;
    });
  }

  var timer = null;
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('form[action="/search"] input[name="q"], .search-header__input')) return;

    // Empêche l'ancien script (ajax « view=json ») de réafficher son propre menu
    input.setAttribute('data-old-term', input.value);

    var query = input.value;
    clearTimeout(timer);
    if (normalize(query).length < MIN_CHARS) {
      var p = panelFor(input);
      if (p) p.hidden = true;
      return;
    }
    timer = setTimeout(function () {
      loadIndex().then(function (items) {
        if (input.value !== query) return; // l'utilisateur a continué à taper
        render(input, search(items, query), query);
      }).catch(function () {
        var p = panelFor(input);
        if (p) p.hidden = true; // en cas d'échec : la recherche classique (Entrée) reste disponible
      });
    }, 120);
  });

  // Les anciens scripts écoutent aussi keyup/change : on garde data-old-term synchronisé
  ['keyup', 'change'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var input = event.target;
      if (input && input.matches && input.matches('.search-header__input')) {
        input.setAttribute('data-old-term', input.value);
      }
    }, true);
  });

  // Préchargement discret au premier focus pour que les résultats apparaissent instantanément
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('.search-header__input')) {
      loadIndex().catch(function () {});
      var panel = panelFor(input);
      if (panel && panel.children.length && normalize(input.value).length >= MIN_CHARS) panel.hidden = false;
    }
  });

  // Navigation clavier (↑ ↓ Entrée Échap)
  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.search-header__input')) return;
    var panel = input.closest('form') && input.closest('form').querySelector('.md-search-results');
    if (!panel || panel.hidden) return;
    var options = panel.querySelectorAll('li[role="option"]');

    if (event.key === 'Escape') { panel.hidden = true; return; }
    if (!options.length) return;

    var active = parseInt(panel.dataset.active || '-1', 10);
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      active = event.key === 'ArrowDown' ? Math.min(options.length - 1, active + 1) : Math.max(0, active - 1);
      panel.dataset.active = String(active);
      options.forEach(function (o, i) { o.classList.toggle('is-active', i === active); });
      options[active].scrollIntoView({ block: 'nearest' });
    } else if (event.key === 'Enter' && active >= 0) {
      event.preventDefault();
      window.location.href = options[active].querySelector('a').href;
    }
  });

  // Clic en dehors : on ferme
  document.addEventListener('click', function (event) {
    var form = event.target.closest && event.target.closest('form.search-header, form[action="/search"]');
    closeAll(form ? form.querySelector('.md-search-results') : null);
  });
})();
